var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1165 15.6447C10.0223 15.2794 9.83186 14.946 9.5651 14.6793C9.29834 14.4125 8.96497 14.2221 8.59968 14.1279L2.1239 12.458C2.01342 12.4266 1.91618 12.3601 1.84694 12.2685C1.7777 12.1768 1.74023 12.0651 1.74023 11.9503C1.74023 11.8354 1.7777 11.7237 1.84694 11.6321C1.91618 11.5404 2.01342 11.4739 2.1239 11.4425L8.59968 9.77161C8.96485 9.67747 9.29813 9.48722 9.56487 9.22066C9.83162 8.9541 10.0221 8.62095 10.1165 8.25585L11.7864 1.78007C11.8174 1.66915 11.8839 1.57143 11.9757 1.50182C12.0674 1.43221 12.1794 1.39453 12.2946 1.39453C12.4098 1.39453 12.5218 1.43221 12.6136 1.50182C12.7054 1.57143 12.7718 1.66915 12.8029 1.78007L14.4717 8.25585C14.5659 8.62114 14.7563 8.95451 15.0231 9.22127C15.2898 9.48803 15.6232 9.67843 15.9885 9.77267L22.4643 11.4425C22.5752 11.4736 22.6729 11.5401 22.7425 11.6318C22.8121 11.7236 22.8498 11.8356 22.8498 11.9508C22.8498 12.066 22.8121 12.178 22.7425 12.2698C22.6729 12.3615 22.5752 12.428 22.4643 12.459L15.9885 14.1279C15.6232 14.2221 15.2898 14.4125 15.0231 14.6793C14.7563 14.946 14.5659 15.2794 14.4717 15.6447L12.8018 22.1205C12.7708 22.2314 12.7043 22.3291 12.6125 22.3987C12.5208 22.4683 12.4087 22.506 12.2936 22.506C12.1784 22.506 12.0664 22.4683 11.9746 22.3987C11.8828 22.3291 11.8164 22.2314 11.7853 22.1205L10.1165 15.6447Z",
    stroke: "#0D6CF9",
    strokeWidth: 2.19906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7383 2.4502V6.67238",
    stroke: "#0D6CF9",
    strokeWidth: 2.19906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8491 4.56152H18.627",
    stroke: "#0D6CF9",
    strokeWidth: 2.19906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84961 17.2275V19.3386",
    stroke: "#0D6CF9",
    strokeWidth: 2.19906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90406 18.2832H2.79297",
    stroke: "#0D6CF9",
    strokeWidth: 2.19906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.24c490372d9a27317ee76e63b5d2406c.svg";
export { ForwardRef as ReactComponent };